import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import Footer from 'components/footer';

import { Header } from './components';
const { Content } = Layout;

const AppLayout = () => {
  return (
    <div className='form-layout'>
      <Layout className="app-layout">
        <Header />
        <Content className="app-layout__content">
          <Outlet />
        </Content>
      </Layout>
      <Footer/>
    </div>
  );
};

export default AppLayout;
